import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-custact-plans',
  templateUrl: './custact-plans.component.html',
  styleUrls: ['./custact-plans.component.css']
})
export class CustactPlansComponent implements OnInit {
    public setting?: Setting;

    public selectListLabours: Item[] = [];

    public itemsListPlans: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(797))[0];
    }

    private async loadLabours() {
        this.selectListLabours = await this.datatask.Post(101, { activestatus: 'ACT' });
    }

    private async loadPlans() {
        if (!this.setting) return;

        return this.itemsListPlans = await this.datatask.Post(798, this.setting);
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'labour_no':
                this.loadPlans();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadLabours();
        this.loadPlans();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    labour_no: string;
    show_setting: string;
    show_other_labours: string;
    labour_name: string;
}
